import { render, staticRenderFns } from "./employeeOfTheMonth.vue?vue&type=template&id=0b95a9c6"
import script from "./employeeOfTheMonth.vue?vue&type=script&lang=ts"
export * from "./employeeOfTheMonth.vue?vue&type=script&lang=ts"
import style0 from "./employeeOfTheMonth.vue?vue&type=style&index=0&id=0b95a9c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports